import {
  getClearActionType,
  getErrorActionType,
  getSuccessActionType,
  getUpdatedUser,
  getUserFromAccessToken,
  setAccessToken,
  setRefreshToken,
} from "_helpers";

const {
  SIGNUP,
  SIGN_IN,
  CHANGE_PASSWORD,
  REFRESH_TOKEN,
  LOGOUT,
  SUBMIT_DOCUMENTS,
  SUBMIT_EMPLOYMENT_DETAILS,
  UPDATE_EMPLOYMENT_DETAILS,
  FETCH_EMPLOYMENT_DETAILS,
  FETCH_FINANCIAL_DETAILS,
  SUBMIT_FINANCIAL_DETAILS,
  UPDATE_FINANCIAL_DETAILS,
  FETCH_PERSONAL_DETAILS,
  SUBMIT_PERSONAL_DETAILS,
  UPDATE_PERSONAL_DETAILS,
  FETCH_COUNTRIES,
  FETCH_INDUSTRIES,
  FETCH_ONBOARDING_STATUS,
  ONBOARDING_VALIDATE,
  ONBOARDING_REGISTER,
  FETCH_TRADING_EXPERIENCE,
  SUBMIT_TRADING_EXPERIENCE,
  UPDATE_TRADING_EXPERIENCE,
  FETCH_TRADING_ACCOUNTS,
  SUBMIT_TRADING_ACCOUNTS,
  SEND_OTP,
  VERIFY_OTP,
  FETCH_USER,
  SOCIAL_SIGN_IN,
  SET_SIGNUP_DETAILS,
  SOCIAL_SIGNUP,
  EMAIL_VERIFICATION,
  PHONE_VERIFICATION,
  FETCH_ACCOUNT_TYPES,
  FETCH_PLATFORM_SERVERS,
  FORGOT_PASSWORD_RESET,
  INITIATE_FORGOT_PASSWORD,
  UPDATE_LEVERAGE,
  INITIATE_RESET_PASSWORD,
  RESET_PASSWORD,
  FETCH_INTRODUCING_BROKER_APPLICATION,
  SUBMIT_INTRODUCING_BROKER_APPLICATION,
  FETCH_REFERRAL_LINKS,
  SUBMIT_REFERRAL_LINK,
  FETCH_NEWS,
  FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION,
  FETCH_CLIENT_CABINET_CLIENT_COMMISSION,
  FETCH_CLIENT_CABINET_COMMISSION_SETTINGS,
  FETCH_CLIENT_CABINET_IB_COMMISSIONS,
  FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD,
  FETCH_CLIENT_CABINET_IB_REFERRALS,
  FETCH_CLIENT_CABINET_IB_TRANSACTIONS,
  MONITORING_CLIENTS,
  MONITORING_META_CLIENTS,
  TRANSFERS,
  FETCH_SOCIAL_TRADING_PROVIDERS,
  FETCH_SOCIAL_TRADING_PROVIDER_OFFERS,
  SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER,
  SUBMIT_SOCIAL_TRADING_PROVIDER,
  SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER,
  FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS,
  FETCH_SOCIAL_TRADING_PROVIDER_CONFIG,
  FETCH_SOCIAL_TRADING_PROVIDER_DETAILS,
  FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART,
  FETCH_SOCIAL_TRADING_PROVIDER_METRICS,
  FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS,
  FETCH_SOCIAL_TRADING_PROVIDER_DEALS,
  UPDATE_SOCIAL_TRADING_PROVIDER,
  FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO,
  UPDATE_SOCIAL_TRADING_SUBSCRIPTION,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK,
  UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK,
  DELETE_SOCIAL_TRADING_SUBSCRIPTION,
  FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO,
  FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS,
  FETCH_SOCIAL_TRADING_OFFER_DETAILS,
  FETCH_SOCIAL_TRADING_FEES,
  SUBMIT_PROVIDER_APPLICATION,
  FETCH_SOCIAL_TRADING_RATE_PROFILE,
  FETCH_SOCIAL_TRADING_HISTORY_INDICATORS,
  FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT,
  FETCH_SOCIAL_TRADING_TRADE_REPORT,
  FETCH_CONTACTS,
  SUBMIT_CONTACT,
  FETCH_SWAP_FREE_DETAILS,
  SUBMIT_SWAP_FREE,
  HYDRATE_USER,
} = require("_constants");

const initialState = {
  signupStatus: null,

  user: null,
  userStatus: null,

  signInStatus: null,

  changePasswordStatus: null,

  refreshTokenStatus: null,

  logoutStatus: null,

  documents: null,
  documentsStatus: null,

  employmentDetails: null,
  employmentDetailsStatus: null,
  submitEmploymentDetailsStatus: null,
  updateEmploymentDetailsStatus: null,

  financialDetails: null,
  financialDetailsStatus: null,
  submitFinancialDetailsStatus: null,
  updateFinancialDetailsStatus: null,

  personalDetails: null,
  personalDetailsStatus: null,
  submitPersonalDetailsStatus: null,
  updatePersonalDetailsStatus: null,

  countries: null,
  countriesStatus: null,

  industries: null,
  industriesStatus: null,

  onboardingStatus: null,
  onboardingStatusDetails: null,

  onboardingValidateStatus: null,

  onboardingRegisterStatus: null,
  tradingExperience: null,
  tradingExperienceStatus: null,
  submitTradingExperienceStatus: null,
  updateTradingExperienceStatus: null,

  tradingAccountsStatus: null,
  tradingAccounts: null,
  submitTradingAccountsStatus: null,
  submittedTradingAccountData: null,

  sendOTPStatus: null,
  verifyOTPStatus: null,

  socialSignInStatus: null,
  socialSignInError: null,

  socialSignupStatus: null,

  signupDetails: null,

  accountTypes: null,
  accountTypesStatus: null,

  platformServers: null,
  platformServersStatus: null,

  initiateForgotPasswordStatus: null,

  forgotPasswordResetStatus: null,

  updateLeverageStatus: null,

  initiateResetPasswordStatus: null,

  resetPasswordStatus: null,

  introducingBrokerApplication: null,
  introducingBrokerApplicationStatus: null,

  submitIntroducingBrokerApplicationStatus: null,

  referralLinks: null,
  referralLinksStatus: null,

  submitReferralLinkStatus: null,

  news: null,
  newsStatus: null,

  clientCabinetAccountCommission: null,
  clientCabinetAccountCommissionStatus: null,

  clientCabinetClientCommission: null,
  clientCabinetClientCommissionStatus: null,

  clientCabinetCommissionSettings: null,
  clientCabinetCommissionSettingsStatus: null,

  clientCabinetIBCommissions: null,
  clientCabinetIBCommissionsStatus: null,

  clientCabinetIBPerformanceDashboard: null,
  clientCabinetIBPerformanceDashboardStatus: null,

  clientCabinetIBReferrals: null,
  clientCabinetIBReferralsStatus: null,

  clientCabinetIBTransactions: null,
  clientCabinetIBTransactionsStatus: null,

  monitorClientsStatus: null,

  monitorMetaClientsStatus: null,

  socialTradingProviders: null,
  socialTradingProvidersStatus: null,

  socialTradingProviderOffers: null,
  socialTradingProviderOffersStatus: null,

  subscribeToSocialTradingProviderStatus: null,

  transfersStatus: null,

  submitSocialTradingProviderStatus: null,

  submitSocialTradingProviderOfferStatus: null,

  socialTradingProviderPositions: null,
  socialTradingProviderPositionsStatus: null,

  socialTradingProvidersConfig: null,
  socialTradingProvidersConfigStatus: null,

  socialTradingHistoryDailyChart: null,
  socialTradingHistoryDailyChartStatus: null,

  socialTradingProviderDetails: null,
  socialTradingProviderDetailsStatus: null,

  socialTradingProviderMetricsStatus: null,
  socialTradingProviderMetrics: null,

  socialTradingProviderSubscriptionsStatus: null,
  socialTradingProviderSubscriptions: null,

  socialTradingProviderDealsStatus: null,
  socialTradingProviderDeals: null,

  updateSocialTradingProviderStatus: null,

  socialTradingProviderPortfolioStatus: null,
  socialTradingProviderPortfolio: null,

  updateSocialTradingSubscriptionStatus: null,

  socialTradingSubscriptionDetailsStatus: null,
  socialTradingSubscriptionDetails: null,

  socialTradingSubscriptionDealsStatus: null,
  socialTradingSubscriptionDeals: null,

  socialTradingSubscriptionMetricsStatus: null,
  socialTradingSubscriptionMetrics: null,

  socialTradingSubscriptionTradingResultsStatus: null,
  socialTradingSubscriptionTradingResults: null,

  socialTradingSubscriptionRiskStatus: null,
  socialTradingSubscriptionRisk: null,

  updateSocialTradingSubscriptionRiskStatus: null,

  deleteSocialTradingSubscriptionStatus: null,

  socialTradingFollowerPortfolioStatus: null,
  socialTradingFollowerPortfolio: null,

  socialTradingFollowerPositionsStatus: null,
  socialTradingFollowerPositions: null,

  socialTradingOfferDetails: null,
  socialTradingOfferDetailsStatus: null,

  socialTradingFees: null,
  socialTradingFeesStatus: null,
  contacts: null,
  contactsStatus: null,

  submitContactStatus: null,

  swapFreeDetailsStatus: null,
  swapFreeDetails: null,

  submitSwapFreeStatus: null,

  submitProviderApplicationStatus: null,

  socialTradingRateProfile: null,
  socialTradingRateProfileStatus: null,

  socialTradingHistoryIndicators: null,
  socialTradingHistoryIndicatorsStatus: null,

  socialTradingInstrumentReport: null,
  socialTradingInstrumentReportStatus: null,

  socialTradingTradeReport: null,
  socialTradingTradeReportStatus: null,
};

const customerManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP:
      return {
        ...state,
        signupStatus: "loading",
      };
    case getSuccessActionType(SIGNUP):
      return {
        ...state,
        signupStatus: "success",
      };
    case getErrorActionType(SIGNUP):
      return {
        ...state,
        signupStatus: "error",
      };
    case getClearActionType(SIGNUP):
      return {
        ...state,
        signupStatus: null,
      };
    case SIGN_IN:
      return {
        ...state,
        signInStatus: "loading",
        signupDetails: null,
      };
    case getSuccessActionType(SIGN_IN):
      const shouldHydrateUserFromSignInToken =
        action.successDispatchData?.setUserFromToken !== false;
      setAccessToken(action.payload?.accessToken);
      setRefreshToken(action.payload?.refreshToken);
      return {
        ...state,
        signInStatus: "success",
        user: shouldHydrateUserFromSignInToken
          ? getUserFromAccessToken(action.payload?.accessToken)
          : null,
      };
    case getErrorActionType(SIGN_IN):
      return {
        ...state,
        signInStatus: "error",
      };
    case getClearActionType(SIGN_IN):
      return {
        ...state,
        signInStatus: null,
      };
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordStatus: "loading",
      };
    case getSuccessActionType(CHANGE_PASSWORD):
      return {
        ...state,
        changePasswordStatus: "success",
      };
    case getErrorActionType(CHANGE_PASSWORD):
      return {
        ...state,
        changePasswordStatus: "error",
      };
    case getClearActionType(CHANGE_PASSWORD):
      return {
        ...state,
        changePasswordStatus: null,
      };
    case REFRESH_TOKEN:
      return {
        ...state,
        refreshTokenStatus: "loading",
      };
    case getSuccessActionType(REFRESH_TOKEN):
      return {
        ...state,
        refreshTokenStatus: "success",
      };
    case getErrorActionType(REFRESH_TOKEN):
      return {
        ...state,
        refreshTokenStatus: "error",
      };
    case getClearActionType(REFRESH_TOKEN):
      return {
        ...state,
        refreshTokenStatus: null,
      };
    case LOGOUT:
      return {
        ...state,
        logoutStatus: "loading",
      };
    case getSuccessActionType(LOGOUT):
      setAccessToken(null);
      setRefreshToken(null);
      return {
        ...state,
        logoutStatus: "success",
        user: null,
        personalDetails: null,
        financialDetails: null,
        employmentDetails: null,
      };
    case getErrorActionType(LOGOUT):
      return {
        ...state,
        logoutStatus: "error",
      };
    case getClearActionType(LOGOUT):
      return {
        ...state,
        logoutStatus: null,
      };
    case SUBMIT_DOCUMENTS:
      return {
        ...state,
        documentsStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_DOCUMENTS):
      return {
        ...state,
        documentsStatus: "success",
        documents: action.payload,
      };
    case getErrorActionType(SUBMIT_DOCUMENTS):
      return {
        ...state,
        documentsStatus: "error",
      };
    case getClearActionType(SUBMIT_DOCUMENTS):
      return {
        ...state,
        documentsStatus: null,
      };
    case SUBMIT_EMPLOYMENT_DETAILS:
      return {
        ...state,
        submitEmploymentDetailsStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_EMPLOYMENT_DETAILS):
      return {
        ...state,
        employmentDetails: action.payload,
        submitEmploymentDetailsStatus: "success",
      };
    case getErrorActionType(SUBMIT_EMPLOYMENT_DETAILS):
      return {
        ...state,
        submitEmploymentDetailsStatus: "error",
      };
    case getClearActionType(SUBMIT_EMPLOYMENT_DETAILS):
      return {
        ...state,
        submitEmploymentDetailsStatus: null,
      };
    case UPDATE_EMPLOYMENT_DETAILS:
      return {
        ...state,
        updateEmploymentDetailsStatus: "loading",
      };
    case getSuccessActionType(UPDATE_EMPLOYMENT_DETAILS):
      return {
        ...state,
        employmentDetails: action.payload,
        updateEmploymentDetailsStatus: "success",
      };
    case getErrorActionType(UPDATE_EMPLOYMENT_DETAILS):
      return {
        ...state,
        updateEmploymentDetailsStatus: "error",
      };
    case getClearActionType(UPDATE_EMPLOYMENT_DETAILS):
      return {
        ...state,
        updateEmploymentDetailsStatus: null,
      };
    case FETCH_EMPLOYMENT_DETAILS:
      return {
        ...state,
        employmentDetailsStatus: "loading",
      };
    case getSuccessActionType(FETCH_EMPLOYMENT_DETAILS):
      return {
        ...state,
        employmentDetailsStatus: "success",
        employmentDetails: action.payload,
      };
    case getErrorActionType(FETCH_EMPLOYMENT_DETAILS):
      return {
        ...state,
        employmentDetailsStatus: "error",
      };
    case getClearActionType(FETCH_EMPLOYMENT_DETAILS):
      return {
        ...state,
        employmentDetailsStatus: null,
      };
    case FETCH_FINANCIAL_DETAILS:
      return {
        ...state,
        financialDetailsStatus: "loading",
      };
    case getSuccessActionType(FETCH_FINANCIAL_DETAILS):
      return {
        ...state,
        financialDetailsStatus: "success",
        financialDetails: action.payload,
      };
    case getErrorActionType(FETCH_FINANCIAL_DETAILS):
      return {
        ...state,
        financialDetailsStatus: "error",
      };
    case getClearActionType(FETCH_FINANCIAL_DETAILS):
      return {
        ...state,
        financialDetailsStatus: null,
      };
    case SUBMIT_FINANCIAL_DETAILS:
      return {
        ...state,
        submitFinancialDetailsStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_FINANCIAL_DETAILS):
      return {
        ...state,
        submitFinancialDetailsStatus: "success",
      };
    case getErrorActionType(SUBMIT_FINANCIAL_DETAILS):
      return {
        ...state,
        submitFinancialDetailsStatus: "error",
      };
    case getClearActionType(SUBMIT_FINANCIAL_DETAILS):
      return {
        ...state,
        submitFinancialDetailsStatus: null,
      };
    case UPDATE_FINANCIAL_DETAILS:
      return {
        ...state,
        updateFinancialDetailsStatus: "loading",
      };
    case getSuccessActionType(UPDATE_FINANCIAL_DETAILS):
      return {
        ...state,
        updateFinancialDetailsStatus: "success",
      };
    case getErrorActionType(UPDATE_FINANCIAL_DETAILS):
      return {
        ...state,
        updateFinancialDetailsStatus: "error",
      };
    case getClearActionType(UPDATE_FINANCIAL_DETAILS):
      return {
        ...state,
        updateFinancialDetailsStatus: null,
      };
    case FETCH_PERSONAL_DETAILS:
      return {
        ...state,
        personalDetailsStatus: "loading",
      };
    case getSuccessActionType(FETCH_PERSONAL_DETAILS):
      return {
        ...state,
        personalDetails: action.payload,
        personalDetailsStatus: "success",
      };
    case getErrorActionType(FETCH_PERSONAL_DETAILS):
      return {
        ...state,
        personalDetailsStatus: "error",
      };
    case getClearActionType(FETCH_PERSONAL_DETAILS):
      return {
        ...state,
        personalDetailsStatus: null,
      };
    case SUBMIT_PERSONAL_DETAILS:
      return {
        ...state,
        submitPersonalDetailsStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_PERSONAL_DETAILS):
      return {
        ...state,
        submitPersonalDetailsStatus: "success",
      };
    case getErrorActionType(SUBMIT_PERSONAL_DETAILS):
      return {
        ...state,
        submitPersonalDetailsStatus: "error",
      };
    case getClearActionType(SUBMIT_PERSONAL_DETAILS):
      return {
        ...state,
        submitPersonalDetailsStatus: null,
      };
    case UPDATE_PERSONAL_DETAILS:
      return {
        ...state,
        updatePersonalDetailsStatus: "loading",
      };
    case getSuccessActionType(UPDATE_PERSONAL_DETAILS):
      return {
        ...state,
        updatePersonalDetailsStatus: "success",
      };
    case getErrorActionType(UPDATE_PERSONAL_DETAILS):
      return {
        ...state,
        updatePersonalDetailsStatus: "error",
      };
    case getClearActionType(UPDATE_PERSONAL_DETAILS):
      return {
        ...state,
        updatePersonalDetailsStatus: null,
      };
    case FETCH_COUNTRIES:
      return {
        ...state,
        countriesStatus: "loading",
      };
    case getSuccessActionType(FETCH_COUNTRIES):
      return {
        ...state,
        countriesStatus: "success",
        countries: action.payload,
      };
    case getErrorActionType(FETCH_COUNTRIES):
      return {
        ...state,
        countriesStatus: "error",
      };
    case getClearActionType(FETCH_COUNTRIES):
      return {
        ...state,
        countriesStatus: null,
      };
    case FETCH_INDUSTRIES:
      return {
        ...state,
        industriesStatus: "loading",
      };
    case getSuccessActionType(FETCH_INDUSTRIES):
      return {
        ...state,
        industriesStatus: "success",
        industries: action.payload,
      };
    case getErrorActionType(FETCH_INDUSTRIES):
      return {
        ...state,
        industriesStatus: "error",
      };
    case getClearActionType(FETCH_INDUSTRIES):
      return {
        ...state,
        industriesStatus: null,
      };
    case FETCH_ONBOARDING_STATUS:
      return {
        ...state,
        onboardingStatus: "loading",
      };
    case getSuccessActionType(FETCH_ONBOARDING_STATUS):
      return {
        ...state,
        onboardingStatus: "success",
        onboardingStatusDetails: action.payload,
      };
    case getErrorActionType(FETCH_ONBOARDING_STATUS):
      return {
        ...state,
        onboardingStatus: "error",
      };
    case getClearActionType(FETCH_ONBOARDING_STATUS):
      return {
        ...state,
        onboardingStatus: null,
      };

    case ONBOARDING_VALIDATE:
      return {
        ...state,
        onboardingValidateStatus: "loading",
      };
    case getSuccessActionType(ONBOARDING_VALIDATE):
      return {
        ...state,
        onboardingValidateStatus: "success",
      };
    case getErrorActionType(ONBOARDING_VALIDATE):
      return {
        ...state,
        onboardingValidateStatus: "error",
      };
    case getClearActionType(ONBOARDING_VALIDATE):
      return {
        ...state,
        onboardingValidateStatus: null,
      };

    case ONBOARDING_REGISTER:
      return {
        ...state,
        onboardingRegisterStatus: "loading",
      };
    case getSuccessActionType(ONBOARDING_REGISTER):
      return {
        ...state,
        onboardingRegisterStatus: "success",
      };
    case getErrorActionType(ONBOARDING_REGISTER):
      return {
        ...state,
        onboardingRegisterStatus: "error",
      };
    case getClearActionType(ONBOARDING_REGISTER):
      return {
        ...state,
        onboardingRegisterStatus: null,
      };
    case FETCH_TRADING_EXPERIENCE:
      return {
        ...state,
        tradingExperienceStatus: "loading",
      };
    case getSuccessActionType(FETCH_TRADING_EXPERIENCE):
      return {
        ...state,
        tradingExperienceStatus: "success",
        tradingExperience: action.payload,
      };
    case getErrorActionType(FETCH_TRADING_EXPERIENCE):
      return {
        ...state,
        tradingExperienceStatus: "error",
        tradingExperience: null,
      };
    case getClearActionType(FETCH_TRADING_EXPERIENCE):
      return {
        ...state,
        tradingExperienceStatus: null,
      };
    case SUBMIT_TRADING_EXPERIENCE:
      return {
        ...state,
        submitTradingExperienceStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_TRADING_EXPERIENCE):
      return {
        ...state,
        submitTradingExperienceStatus: "success",
        tradingExperience: action.payload,
      };
    case getErrorActionType(SUBMIT_TRADING_EXPERIENCE):
      return {
        ...state,
        submitTradingExperienceStatus: "error",
      };
    case getClearActionType(SUBMIT_TRADING_EXPERIENCE):
      return {
        ...state,
        submitTradingExperienceStatus: null,
      };
    case UPDATE_TRADING_EXPERIENCE:
      return {
        ...state,
        updateTradingExperienceStatus: "loading",
      };
    case getSuccessActionType(UPDATE_TRADING_EXPERIENCE):
      return {
        ...state,
        updateTradingExperienceStatus: "success",
        tradingExperience: action.payload,
      };
    case getErrorActionType(UPDATE_TRADING_EXPERIENCE):
      return {
        ...state,
        updateTradingExperienceStatus: "error",
      };
    case getClearActionType(UPDATE_TRADING_EXPERIENCE):
      return {
        ...state,
        updateTradingExperienceStatus: null,
      };

    case FETCH_TRADING_ACCOUNTS:
      return {
        ...state,
        tradingAccountsStatus: "loading",
      };
    case getSuccessActionType(FETCH_TRADING_ACCOUNTS):
      return {
        ...state,
        tradingAccountsStatus: "success",
        tradingAccounts: action.payload,
      };
    case getErrorActionType(FETCH_TRADING_ACCOUNTS):
      return {
        ...state,
        tradingAccountsStatus: "error",
      };
    case getClearActionType(FETCH_TRADING_ACCOUNTS):
      return {
        ...state,
        tradingAccountsStatus: null,
      };

    case SUBMIT_TRADING_ACCOUNTS:
      return {
        ...state,
        submitTradingAccountsStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_TRADING_ACCOUNTS):
      return {
        ...state,
        submitTradingAccountsStatus: "success",
        submittedTradingAccountData: action.payload,
      };
    case getErrorActionType(SUBMIT_TRADING_ACCOUNTS):
      return {
        ...state,
        submitTradingAccountsStatus: "error",
      };
    case getClearActionType(SUBMIT_TRADING_ACCOUNTS):
      return {
        ...state,
        submitTradingAccountsStatus: null,
        submittedTradingAccountData: null,
      };
    case SEND_OTP:
      return {
        ...state,
        sendOTPStatus: "loading",
      };
    case getSuccessActionType(SEND_OTP):
      return {
        ...state,
        sendOTPStatus: "success",
      };
    case getErrorActionType(SEND_OTP):
      return {
        ...state,
        sendOTPStatus: "error",
      };
    case getClearActionType(SEND_OTP):
      return {
        ...state,
        sendOTPStatus: null,
      };
    case VERIFY_OTP:
      return {
        ...state,
        verifyOTPStatus: "loading",
      };
    case getSuccessActionType(VERIFY_OTP):
      let user = null;
      if (state.user) {
        user = {
          ...state.user,
          phoneNumber: action.successDispatchData.phoneNumber,
        };
      }
      return {
        ...state,
        verifyOTPStatus: "success",
        user: user,
      };
    case getErrorActionType(VERIFY_OTP):
      return {
        ...state,
        verifyOTPStatus: "error",
      };
    case getClearActionType(VERIFY_OTP):
      return {
        ...state,
        verifyOTPStatus: null,
      };

    case FETCH_USER:
      return {
        ...state,
        userStatus: "loading",
      };
    case getSuccessActionType(FETCH_USER):
      return {
        ...state,
        userStatus: "success",
        user: getUpdatedUser(state.user, action.payload),
      };
    case getErrorActionType(FETCH_USER):
      return {
        ...state,
        userStatus: "error",
      };
    case getClearActionType(FETCH_USER):
      return {
        ...state,
        userStatus: null,
      };
    case SOCIAL_SIGN_IN:
      return {
        ...state,
        socialSignInStatus: "loading",
        signupDetails: null,
      };
    case getSuccessActionType(SOCIAL_SIGN_IN):
      setAccessToken(action.payload?.accessToken);
      setRefreshToken(action.payload?.refreshToken);
      return {
        ...state,
        socialSignInStatus: "success",
        user: {
          ...getUserFromAccessToken(action.payload?.accessToken),
          isSignup: !action.payload?.emailExists,
          googleUser: true,
        },
      };
    case getErrorActionType(SOCIAL_SIGN_IN):
      return {
        ...state,
        socialSignInStatus: "error",
        socialSignInError: action.error?.data || null,
      };
    case getClearActionType(SOCIAL_SIGN_IN):
      return {
        ...state,
        socialSignInStatus: null,
        socialSignInError: null,
      };

    case SOCIAL_SIGNUP:
      return {
        ...state,
        socialSignupStatus: "loading",
      };
    case getSuccessActionType(SOCIAL_SIGNUP):
      return {
        ...state,
        socialSignupStatus: "success",
        user: { ...(state.user || {}), ...action?.successDispatchData },
      };
    case getErrorActionType(SOCIAL_SIGNUP):
      return {
        ...state,
        socialSignupStatus: "error",
      };
    case getClearActionType(SOCIAL_SIGNUP):
      return {
        ...state,
        socialSignupStatus: null,
      };

    case SET_SIGNUP_DETAILS:
      let currentSignupDetails = { ...(state.signupDetails || {}) };
      if (typeof action.payload === "object") {
        currentSignupDetails = { ...currentSignupDetails, ...action.payload };
      } else {
        currentSignupDetails = null;
      }
      return {
        ...state,
        signupDetails: currentSignupDetails,
      };

    case HYDRATE_USER:
      return {
        ...state,
        user: action.payload,
      };

    case EMAIL_VERIFICATION:
      return {
        ...state,
        emailVerificationStatus: "loading",
      };
    case getSuccessActionType(EMAIL_VERIFICATION):
      return {
        ...state,
        emailVerificationStatus: "success",
        user: null,
      };
    case getErrorActionType(EMAIL_VERIFICATION):
      return {
        ...state,
        emailVerificationStatus: "error",
      };
    case getClearActionType(EMAIL_VERIFICATION):
      return {
        ...state,
        emailVerificationStatus: null,
      };

    case PHONE_VERIFICATION:
      return {
        ...state,
        phoneVerificationStatus: "loading",
      };
    case getSuccessActionType(PHONE_VERIFICATION):
      return {
        ...state,
        phoneVerificationStatus: "success",
      };
    case getErrorActionType(PHONE_VERIFICATION):
      return {
        ...state,
        phoneVerificationStatus: "error",
      };
    case getClearActionType(PHONE_VERIFICATION):
      return {
        ...state,
        phoneVerificationStatus: null,
      };

    case FETCH_ACCOUNT_TYPES:
      return {
        ...state,
        accountTypesStatus: "loading",
      };
    case getSuccessActionType(FETCH_ACCOUNT_TYPES):
      return {
        ...state,
        accountTypesStatus: "success",
        accountTypes: action.payload,
      };
    case getErrorActionType(FETCH_ACCOUNT_TYPES):
      return {
        ...state,
        accountTypesStatus: "error",
      };
    case getClearActionType(FETCH_ACCOUNT_TYPES):
      return {
        ...state,
        accountTypesStatus: null,
      };

    case FETCH_PLATFORM_SERVERS:
      return {
        ...state,
        platformServersStatus: "loading",
      };
    case getSuccessActionType(FETCH_PLATFORM_SERVERS):
      return {
        ...state,
        platformServersStatus: "success",
        platformServers: action.payload,
      };
    case getErrorActionType(FETCH_PLATFORM_SERVERS):
      return {
        ...state,
        platformServersStatus: "error",
      };
    case getClearActionType(FETCH_PLATFORM_SERVERS):
      return {
        ...state,
        platformServersStatus: null,
      };

    case INITIATE_FORGOT_PASSWORD:
      return {
        ...state,
        initiateForgotPasswordStatus: "loading",
      };
    case getSuccessActionType(INITIATE_FORGOT_PASSWORD):
      return {
        ...state,
        initiateForgotPasswordStatus: "success",
      };
    case getErrorActionType(INITIATE_FORGOT_PASSWORD):
      return {
        ...state,
        initiateForgotPasswordStatus: "error",
      };
    case getClearActionType(INITIATE_FORGOT_PASSWORD):
      return {
        ...state,
        initiateForgotPasswordStatus: null,
      };

    case FORGOT_PASSWORD_RESET:
      return {
        ...state,
        forgotPasswordResetStatus: "loading",
      };
    case getSuccessActionType(FORGOT_PASSWORD_RESET):
      return {
        ...state,
        forgotPasswordResetStatus: "success",
      };
    case getErrorActionType(FORGOT_PASSWORD_RESET):
      return {
        ...state,
        forgotPasswordResetStatus: "error",
      };
    case getClearActionType(FORGOT_PASSWORD_RESET):
      return {
        ...state,
        forgotPasswordResetStatus: null,
      };

    case UPDATE_LEVERAGE:
      return {
        ...state,
        updateLeverageStatus: "loading",
      };
    case getSuccessActionType(UPDATE_LEVERAGE):
      return {
        ...state,
        updateLeverageStatus: "success",
      };
    case getErrorActionType(UPDATE_LEVERAGE):
      return {
        ...state,
        updateLeverageStatus: "error",
      };
    case getClearActionType(UPDATE_LEVERAGE):
      return {
        ...state,
        updateLeverageStatus: null,
      };

    case INITIATE_RESET_PASSWORD:
      return {
        ...state,
        initiateResetPasswordStatus: "loading",
      };
    case getSuccessActionType(INITIATE_RESET_PASSWORD):
      return {
        ...state,
        initiateResetPasswordStatus: "success",
      };
    case getErrorActionType(INITIATE_RESET_PASSWORD):
      return {
        ...state,
        initiateResetPasswordStatus: "error",
      };
    case getClearActionType(INITIATE_RESET_PASSWORD):
      return {
        ...state,
        initiateResetPasswordStatus: null,
      };

    case RESET_PASSWORD:
      return {
        ...state,
        resetPasswordStatus: "loading",
      };
    case getSuccessActionType(RESET_PASSWORD):
      return {
        ...state,
        resetPasswordStatus: "success",
      };
    case getErrorActionType(RESET_PASSWORD):
      return {
        ...state,
        resetPasswordStatus: "error",
      };
    case getClearActionType(RESET_PASSWORD):
      return {
        ...state,
        resetPasswordStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDERS:
      return {
        ...state,
        socialTradingProvidersStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDERS):
      return {
        ...state,
        socialTradingProvidersStatus: "success",
        socialTradingProviders: action.payload?.items,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDERS):
      return {
        ...state,
        socialTradingProvidersStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDERS):
      return {
        ...state,
        socialTradingProvidersStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_OFFERS:
      return {
        ...state,
        socialTradingProviderOffersStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_OFFERS):
      return {
        ...state,
        socialTradingProviderOffersStatus: "success",
        socialTradingProviderOffers: action.payload?.items,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_OFFERS):
      return {
        ...state,
        socialTradingProviderOffersStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_OFFERS):
      return {
        ...state,
        socialTradingProviderOffersStatus: null,
      };

    case SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER:
      return {
        ...state,
        subscribeToSocialTradingProviderStatus: "loading",
      };
    case getSuccessActionType(SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        subscribeToSocialTradingProviderStatus: "success",
      };
    case getErrorActionType(SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        subscribeToSocialTradingProviderStatus: "error",
      };
    case getClearActionType(SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        subscribeToSocialTradingProviderStatus: null,
      };

    case TRANSFERS:
      return {
        ...state,
        transfersStatus: "loading",
      };
    case getSuccessActionType(TRANSFERS):
      return {
        ...state,
        transfersStatus: "success",
      };
    case getErrorActionType(TRANSFERS):
      return {
        ...state,
        transfersStatus: "error",
      };
    case getClearActionType(TRANSFERS):
      return {
        ...state,
        transfersStatus: null,
      };

    case FETCH_INTRODUCING_BROKER_APPLICATION:
      return {
        ...state,
        introducingBrokerApplicationStatus: "loading",
      };
    case getSuccessActionType(FETCH_INTRODUCING_BROKER_APPLICATION):
      return {
        ...state,
        introducingBrokerApplicationStatus: "success",
        introducingBrokerApplication: action.payload,
      };
    case getErrorActionType(FETCH_INTRODUCING_BROKER_APPLICATION):
      return {
        ...state,
        introducingBrokerApplicationStatus: "error",
      };
    case getClearActionType(FETCH_INTRODUCING_BROKER_APPLICATION):
      return {
        ...state,
        introducingBrokerApplicationStatus: null,
      };

    case SUBMIT_INTRODUCING_BROKER_APPLICATION:
      return {
        ...state,
        submitIntroducingBrokerApplicationStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_INTRODUCING_BROKER_APPLICATION):
      return {
        ...state,
        submitIntroducingBrokerApplicationStatus: "success",
      };
    case getErrorActionType(SUBMIT_INTRODUCING_BROKER_APPLICATION):
      return {
        ...state,
        submitIntroducingBrokerApplicationStatus: "error",
      };
    case getClearActionType(SUBMIT_INTRODUCING_BROKER_APPLICATION):
      return {
        ...state,
        submitIntroducingBrokerApplicationStatus: null,
      };

    case FETCH_REFERRAL_LINKS:
      return {
        ...state,
        referralLinksStatus: "loading",
      };
    case getSuccessActionType(FETCH_REFERRAL_LINKS):
      return {
        ...state,
        referralLinksStatus: "success",
        referralLinks: action.payload,
      };
    case getErrorActionType(FETCH_REFERRAL_LINKS):
      return {
        ...state,
        referralLinksStatus: "error",
      };
    case getClearActionType(FETCH_REFERRAL_LINKS):
      return {
        ...state,
        referralLinksStatus: null,
      };

    case SUBMIT_REFERRAL_LINK:
      return {
        ...state,
        submitReferralLinkStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_REFERRAL_LINK):
      return {
        ...state,
        submitReferralLinkStatus: "success",
      };
    case getErrorActionType(SUBMIT_REFERRAL_LINK):
      return {
        ...state,
        submitReferralLinkStatus: "error",
      };
    case getClearActionType(SUBMIT_REFERRAL_LINK):
      return {
        ...state,
        submitReferralLinkStatus: null,
      };

    case FETCH_NEWS:
      return {
        ...state,
        newsStatus: "loading",
      };
    case getSuccessActionType(FETCH_NEWS):
      return {
        ...state,
        newsStatus: "success",
        news: action.payload,
      };
    case getErrorActionType(FETCH_NEWS):
      return {
        ...state,
        newsStatus: "error",
      };
    case getClearActionType(FETCH_NEWS):
      return {
        ...state,
        newsStatus: null,
      };

    case FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION:
      return {
        ...state,
        clientCabinetAccountCommissionStatus: "loading",
      };
    case getSuccessActionType(FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION):
      return {
        ...state,
        clientCabinetAccountCommissionStatus: "success",
        clientCabinetAccountCommission: action.payload,
      };
    case getErrorActionType(FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION):
      return {
        ...state,
        clientCabinetAccountCommissionStatus: "error",
      };
    case getClearActionType(FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION):
      return {
        ...state,
        clientCabinetAccountCommissionStatus: null,
      };

    case FETCH_CLIENT_CABINET_CLIENT_COMMISSION:
      return {
        ...state,
        clientCabinetClientCommissionStatus: "loading",
      };
    case getSuccessActionType(FETCH_CLIENT_CABINET_CLIENT_COMMISSION):
      return {
        ...state,
        clientCabinetClientCommissionStatus: "success",
        clientCabinetClientCommission: action.payload,
      };
    case getErrorActionType(FETCH_CLIENT_CABINET_CLIENT_COMMISSION):
      return {
        ...state,
        clientCabinetClientCommissionStatus: "error",
      };
    case getClearActionType(FETCH_CLIENT_CABINET_CLIENT_COMMISSION):
      return {
        ...state,
        clientCabinetClientCommissionStatus: null,
      };

    case FETCH_CLIENT_CABINET_COMMISSION_SETTINGS:
      return {
        ...state,
        clientCabinetCommissionSettingsStatus: "loading",
      };
    case getSuccessActionType(FETCH_CLIENT_CABINET_COMMISSION_SETTINGS):
      return {
        ...state,
        clientCabinetCommissionSettingsStatus: "success",
        clientCabinetCommissionSettings: action.payload,
      };
    case getErrorActionType(FETCH_CLIENT_CABINET_COMMISSION_SETTINGS):
      return {
        ...state,
        clientCabinetCommissionSettingsStatus: "error",
      };
    case getClearActionType(FETCH_CLIENT_CABINET_COMMISSION_SETTINGS):
      return {
        ...state,
        clientCabinetCommissionSettingsStatus: null,
      };

    case FETCH_CLIENT_CABINET_IB_COMMISSIONS:
      return {
        ...state,
        clientCabinetIBCommissionsStatus: "loading",
      };
    case getSuccessActionType(FETCH_CLIENT_CABINET_IB_COMMISSIONS):
      return {
        ...state,
        clientCabinetIBCommissionsStatus: "success",
        clientCabinetIBCommissions: action.payload,
      };
    case getErrorActionType(FETCH_CLIENT_CABINET_IB_COMMISSIONS):
      return {
        ...state,
        clientCabinetIBCommissionsStatus: "error",
      };
    case getClearActionType(FETCH_CLIENT_CABINET_IB_COMMISSIONS):
      return {
        ...state,
        clientCabinetIBCommissionsStatus: null,
      };

    case FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD:
      return {
        ...state,
        clientCabinetIBPerformanceDashboardStatus: "loading",
      };
    case getSuccessActionType(FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD):
      return {
        ...state,
        clientCabinetIBPerformanceDashboardStatus: "success",
        clientCabinetIBPerformanceDashboard: action.payload,
      };
    case getErrorActionType(FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD):
      return {
        ...state,
        clientCabinetIBPerformanceDashboardStatus: "error",
      };
    case getClearActionType(FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD):
      return {
        ...state,
        clientCabinetIBPerformanceDashboardStatus: null,
      };

    case FETCH_CLIENT_CABINET_IB_REFERRALS:
      return {
        ...state,
        clientCabinetIBReferralsStatus: "loading",
      };
    case getSuccessActionType(FETCH_CLIENT_CABINET_IB_REFERRALS):
      return {
        ...state,
        clientCabinetIBReferralsStatus: "success",
        clientCabinetIBReferrals: action.payload,
      };
    case getErrorActionType(FETCH_CLIENT_CABINET_IB_REFERRALS):
      return {
        ...state,
        clientCabinetIBReferralsStatus: "error",
      };
    case getClearActionType(FETCH_CLIENT_CABINET_IB_REFERRALS):
      return {
        ...state,
        clientCabinetIBReferralsStatus: null,
      };

    case FETCH_CLIENT_CABINET_IB_TRANSACTIONS:
      return {
        ...state,
        clientCabinetIBTransactionsStatus: "loading",
      };
    case getSuccessActionType(FETCH_CLIENT_CABINET_IB_TRANSACTIONS):
      return {
        ...state,
        clientCabinetIBTransactionsStatus: "success",
        clientCabinetIBTransactions: action.payload,
      };
    case getErrorActionType(FETCH_CLIENT_CABINET_IB_TRANSACTIONS):
      return {
        ...state,
        clientCabinetIBTransactionsStatus: "error",
      };
    case getClearActionType(FETCH_CLIENT_CABINET_IB_TRANSACTIONS):
      return {
        ...state,
        clientCabinetIBTransactionsStatus: null,
      };

    case MONITORING_CLIENTS:
      return {
        ...state,
        monitorClientsStatus: "loading",
      };
    case getSuccessActionType(MONITORING_CLIENTS):
      return {
        ...state,
        monitorClientsStatus: "success",
      };
    case getErrorActionType(MONITORING_CLIENTS):
      return {
        ...state,
        monitorClientsStatus: "error",
      };
    case getClearActionType(MONITORING_CLIENTS):
      return {
        ...state,
        monitorClientsStatus: null,
      };

    case MONITORING_META_CLIENTS:
      return {
        ...state,
        monitorMetaClientsStatus: "loading",
      };
    case getSuccessActionType(MONITORING_META_CLIENTS):
      return {
        ...state,
        monitorMetaClientsStatus: "success",
      };
    case getErrorActionType(MONITORING_META_CLIENTS):
      return {
        ...state,
        monitorMetaClientsStatus: "error",
      };
    case getClearActionType(MONITORING_META_CLIENTS):
      return {
        ...state,
        monitorMetaClientsStatus: null,
      };

    case SUBMIT_SOCIAL_TRADING_PROVIDER:
      return {
        ...state,
        submitSocialTradingProviderStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        submitSocialTradingProviderStatus: "success",
      };
    case getErrorActionType(SUBMIT_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        submitSocialTradingProviderStatus: "error",
      };
    case getClearActionType(SUBMIT_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        submitSocialTradingProviderStatus: null,
      };

    case SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER:
      return {
        ...state,
        submitSocialTradingProviderOfferStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER):
      return {
        ...state,
        submitSocialTradingProviderOfferStatus: "success",
      };
    case getErrorActionType(SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER):
      return {
        ...state,
        submitSocialTradingProviderOfferStatus: "error",
      };
    case getClearActionType(SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER):
      return {
        ...state,
        submitSocialTradingProviderOfferStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS:
      return {
        ...state,
        socialTradingProviderPositionsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS):
      return {
        ...state,
        socialTradingProviderPositionsStatus: "success",
        socialTradingProviderPositions: action.payload?.items || null,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS):
      return {
        ...state,
        socialTradingProviderPositionsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS):
      return {
        ...state,
        socialTradingProviderPositionsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_CONFIG:
      return {
        ...state,
        socialTradingProvidersConfigStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_CONFIG):
      return {
        ...state,
        socialTradingProvidersConfigStatus: "success",
        socialTradingProvidersConfig: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_CONFIG):
      return {
        ...state,
        socialTradingProvidersConfigStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_CONFIG):
      return {
        ...state,
        socialTradingProvidersConfigStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_DETAILS:
      return {
        ...state,
        socialTradingProviderDetailsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_DETAILS):
      return {
        ...state,
        socialTradingProviderDetailsStatus: "success",
        socialTradingProviderDetails: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_DETAILS):
      return {
        ...state,
        socialTradingProviderDetailsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_DETAILS):
      return {
        ...state,
        socialTradingProviderDetailsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART:
      return {
        ...state,
        socialTradingHistoryDailyChartStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART):
      return {
        ...state,
        socialTradingHistoryDailyChartStatus: "success",
        socialTradingHistoryDailyChart: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART):
      return {
        ...state,
        socialTradingHistoryDailyChartStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART):
      return {
        ...state,
        socialTradingHistoryDailyChartStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_METRICS:
      return {
        ...state,
        socialTradingProviderMetricsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_METRICS):
      return {
        ...state,
        socialTradingProviderMetricsStatus: "success",
        socialTradingProviderMetrics: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_METRICS):
      return {
        ...state,
        socialTradingProviderMetricsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_METRICS):
      return {
        ...state,
        socialTradingProviderMetricsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS:
      return {
        ...state,
        socialTradingProviderSubscriptionsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS):
      return {
        ...state,
        socialTradingProviderSubscriptionsStatus: "success",
        socialTradingProviderSubscriptions: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS):
      return {
        ...state,
        socialTradingProviderSubscriptionsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS):
      return {
        ...state,
        socialTradingProviderSubscriptionsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_DEALS:
      return {
        ...state,
        socialTradingProviderDealsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_DEALS):
      return {
        ...state,
        socialTradingProviderDealsStatus: "success",
        socialTradingProviderDeals: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_DEALS):
      return {
        ...state,
        socialTradingProviderDealsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_DEALS):
      return {
        ...state,
        socialTradingProviderDealsStatus: null,
      };

    case UPDATE_SOCIAL_TRADING_PROVIDER:
      return {
        ...state,
        updateSocialTradingProviderStatus: "loading",
      };
    case getSuccessActionType(UPDATE_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        updateSocialTradingProviderStatus: "success",
      };
    case getErrorActionType(UPDATE_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        updateSocialTradingProviderStatus: "error",
      };
    case getClearActionType(UPDATE_SOCIAL_TRADING_PROVIDER):
      return {
        ...state,
        updateSocialTradingProviderStatus: null,
      };

    case FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO:
      return {
        ...state,
        socialTradingProviderPortfolioStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO):
      return {
        ...state,
        socialTradingProviderPortfolioStatus: "success",
        socialTradingProviderPortfolio: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO):
      return {
        ...state,
        socialTradingProviderPortfolioStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO):
      return {
        ...state,
        socialTradingProviderPortfolioStatus: null,
      };

    case UPDATE_SOCIAL_TRADING_SUBSCRIPTION:
      return {
        ...state,
        updateSocialTradingSubscriptionStatus: "loading",
      };
    case getSuccessActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION):
      return {
        ...state,
        updateSocialTradingSubscriptionStatus: "success",
      };
    case getErrorActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION):
      return {
        ...state,
        updateSocialTradingSubscriptionStatus: "error",
      };
    case getClearActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION):
      return {
        ...state,
        updateSocialTradingSubscriptionStatus: null,
      };

    case FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS:
      return {
        ...state,
        socialTradingSubscriptionDetailsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS):
      return {
        ...state,
        socialTradingSubscriptionDetailsStatus: "success",
        socialTradingSubscriptionDetails: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS):
      return {
        ...state,
        socialTradingSubscriptionDetailsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS):
      return {
        ...state,
        socialTradingSubscriptionDetailsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS:
      return {
        ...state,
        socialTradingSubscriptionDealsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS):
      return {
        ...state,
        socialTradingSubscriptionDealsStatus: "success",
        socialTradingSubscriptionDeals: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS):
      return {
        ...state,
        socialTradingSubscriptionDealsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS):
      return {
        ...state,
        socialTradingSubscriptionDealsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS:
      return {
        ...state,
        socialTradingSubscriptionMetricsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS):
      return {
        ...state,
        socialTradingSubscriptionMetricsStatus: "success",
        socialTradingSubscriptionMetrics: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS):
      return {
        ...state,
        socialTradingSubscriptionMetricsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS):
      return {
        ...state,
        socialTradingSubscriptionMetricsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS:
      return {
        ...state,
        socialTradingSubscriptionTradingResultsStatus: "loading",
      };
    case getSuccessActionType(
      FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS
    ):
      return {
        ...state,
        socialTradingSubscriptionTradingResultsStatus: "success",
        socialTradingSubscriptionTradingResults: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS):
      return {
        ...state,
        socialTradingSubscriptionTradingResultsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS):
      return {
        ...state,
        socialTradingSubscriptionTradingResultsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK:
      return {
        ...state,
        socialTradingSubscriptionRiskStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK):
      return {
        ...state,
        socialTradingSubscriptionRiskStatus: "success",
        socialTradingSubscriptionRisk: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK):
      return {
        ...state,
        socialTradingSubscriptionRiskStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK):
      return {
        ...state,
        socialTradingSubscriptionRiskStatus: null,
      };

    case UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK:
      return {
        ...state,
        updateSocialTradingSubscriptionRiskStatus: "loading",
      };
    case getSuccessActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK):
      return {
        ...state,
        updateSocialTradingSubscriptionRiskStatus: "success",
      };
    case getErrorActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK):
      return {
        ...state,
        updateSocialTradingSubscriptionRiskStatus: "error",
      };
    case getClearActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK):
      return {
        ...state,
        updateSocialTradingSubscriptionRiskStatus: null,
      };

    case DELETE_SOCIAL_TRADING_SUBSCRIPTION:
      return {
        ...state,
        deleteSocialTradingSubscriptionStatus: "loading",
      };
    case getSuccessActionType(DELETE_SOCIAL_TRADING_SUBSCRIPTION):
      return {
        ...state,
        deleteSocialTradingSubscriptionStatus: "success",
      };
    case getErrorActionType(DELETE_SOCIAL_TRADING_SUBSCRIPTION):
      return {
        ...state,
        deleteSocialTradingSubscriptionStatus: "error",
      };
    case getClearActionType(DELETE_SOCIAL_TRADING_SUBSCRIPTION):
      return {
        ...state,
        deleteSocialTradingSubscriptionStatus: null,
      };

    case FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO:
      return {
        ...state,
        socialTradingFollowerPortfolioStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO):
      return {
        ...state,
        socialTradingFollowerPortfolioStatus: "success",
        socialTradingFollowerPortfolio: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO):
      return {
        ...state,
        socialTradingFollowerPortfolioStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO):
      return {
        ...state,
        socialTradingFollowerPortfolioStatus: null,
      };

    case FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS:
      return {
        ...state,
        socialTradingFollowerPositionsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS):
      return {
        ...state,
        socialTradingFollowerPositionsStatus: "success",
        socialTradingFollowerPositions: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS):
      return {
        ...state,
        socialTradingFollowerPositionsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS):
      return {
        ...state,
        socialTradingFollowerPositionsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_OFFER_DETAILS:
      return {
        ...state,
        socialTradingOfferDetailsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_OFFER_DETAILS):
      return {
        ...state,
        socialTradingOfferDetailsStatus: "success",
        socialTradingOfferDetails: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_OFFER_DETAILS):
      return {
        ...state,
        socialTradingOfferDetailsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_OFFER_DETAILS):
      return {
        ...state,
        socialTradingOfferDetailsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_FEES:
      return {
        ...state,
        socialTradingFeesStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_FEES):
      return {
        ...state,
        socialTradingFeesStatus: "success",
        socialTradingFees: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_FEES):
      return {
        ...state,
        socialTradingFeesStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_FEES):
      return {
        ...state,
        socialTradingFeesStatus: null,
      };

    case SUBMIT_PROVIDER_APPLICATION:
      return {
        ...state,
        submitProviderApplicationStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_PROVIDER_APPLICATION):
      return {
        ...state,
        submitProviderApplicationStatus: "success",
      };
    case getErrorActionType(SUBMIT_PROVIDER_APPLICATION):
      return {
        ...state,
        submitProviderApplicationStatus: "error",
      };
    case getClearActionType(SUBMIT_PROVIDER_APPLICATION):
      return {
        ...state,
        submitProviderApplicationStatus: null,
      };

    case FETCH_SOCIAL_TRADING_RATE_PROFILE:
      return {
        ...state,
        socialTradingRateProfileStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_RATE_PROFILE):
      return {
        ...state,
        socialTradingRateProfileStatus: "success",
        socialTradingRateProfile: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_RATE_PROFILE):
      return {
        ...state,
        socialTradingRateProfileStatus: "error",
        socialTradingRateProfile: null,
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_RATE_PROFILE):
      return {
        ...state,
        socialTradingRateProfileStatus: null,
      };

    case FETCH_SOCIAL_TRADING_HISTORY_INDICATORS:
      return {
        ...state,
        socialTradingHistoryIndicatorsStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_HISTORY_INDICATORS):
      return {
        ...state,
        socialTradingHistoryIndicatorsStatus: "success",
        socialTradingHistoryIndicators: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_HISTORY_INDICATORS):
      return {
        ...state,
        socialTradingHistoryIndicatorsStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_HISTORY_INDICATORS):
      return {
        ...state,
        socialTradingHistoryIndicatorsStatus: null,
      };

    case FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT:
      return {
        ...state,
        socialTradingInstrumentReportStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT):
      return {
        ...state,
        socialTradingInstrumentReportStatus: "success",
        socialTradingInstrumentReport: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT):
      return {
        ...state,
        socialTradingInstrumentReportStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT):
      return {
        ...state,
        socialTradingInstrumentReportStatus: null,
      };

    case FETCH_SOCIAL_TRADING_TRADE_REPORT:
      return {
        ...state,
        socialTradingTradeReportStatus: "loading",
      };
    case getSuccessActionType(FETCH_SOCIAL_TRADING_TRADE_REPORT):
      return {
        ...state,
        socialTradingTradeReportStatus: "success",
        socialTradingTradeReport: action.payload,
      };
    case getErrorActionType(FETCH_SOCIAL_TRADING_TRADE_REPORT):
      return {
        ...state,
        socialTradingTradeReportStatus: "error",
      };
    case getClearActionType(FETCH_SOCIAL_TRADING_TRADE_REPORT):
      return {
        ...state,
        socialTradingTradeReportStatus: null,
      };

    case FETCH_CONTACTS:
      return {
        ...state,
        contactsStatus: "loading",
      };
    case getSuccessActionType(FETCH_CONTACTS):
      return {
        ...state,
        contactsStatus: "success",
        contacts: action.payload,
      };
    case getErrorActionType(FETCH_CONTACTS):
      return {
        ...state,
        contactsStatus: "error",
      };
    case getClearActionType(FETCH_CONTACTS):
      return {
        ...state,
        contactsStatus: null,
      };

    case SUBMIT_CONTACT:
      return {
        ...state,
        submitContactStatus: "loading",
      };
    case getSuccessActionType(SUBMIT_CONTACT):
      return {
        ...state,
        submitContactStatus: "success",
      };
    case getErrorActionType(SUBMIT_CONTACT):
      return {
        ...state,
        submitContactStatus: "error",
      };
    case getClearActionType(SUBMIT_CONTACT):
      return {
        ...state,
        submitContactStatus: null,
      };

    case FETCH_SWAP_FREE_DETAILS:
      return {
        ...state,
        swapFreeDetailsStatus: "loading",
      };

    case getSuccessActionType(FETCH_SWAP_FREE_DETAILS):
      return {
        ...state,
        swapFreeDetailsStatus: "success",
        swapFreeDetails: action.payload,
      };

    case getErrorActionType(FETCH_SWAP_FREE_DETAILS):
      return {
        ...state,
        swapFreeDetailsStatus: "error",
      };

    case getClearActionType(FETCH_SWAP_FREE_DETAILS):
      return {
        ...state,
        swapFreeDetailsStatus: null,
      };

    case SUBMIT_SWAP_FREE:
      return {
        ...state,
        submitSwapFreeStatus: "loading",
      };

    case getSuccessActionType(SUBMIT_SWAP_FREE):
      return {
        ...state,
        submitSwapFreeStatus: "success",
      };

    case getErrorActionType(SUBMIT_SWAP_FREE):
      return {
        ...state,
        submitSwapFreeStatus: "error",
      };

    case getClearActionType(SUBMIT_SWAP_FREE):
      return {
        ...state,
        submitSwapFreeStatus: null,
      };

    default:
      return state;
  }
};

export default customerManagementReducer;
